import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';

export const FilterPanel = styled.div`
  background: #fff;
  border: 1px solid ${colors.neutral20};
  border-radius: 8px;
  overflow: hidden;
`;

export const FilterPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid ${colors.neutral20};
`;

export const FilterPanelTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.bigBangBlack};
`;

export const FilterResetBtn = styled.button`
  padding: 4px 12px;
  border: 1px solid ${colors.neutral20};
  border-radius: 4px;
  background: #fff;
  font-family: inherit;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  transition: all 0.15s;
  &:hover {
    color: ${colors.bigBangBlack};
    border-color: #999;
  }
`;

export const VisibilityToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid ${colors.neutral20};
`;

export const VisibilityToggleLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.bigBangBlack};
  cursor: pointer;
  user-select: none;
`;

export const VisibilityToggleInput = styled.input`
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: #4338ca;
`;

export const FilterSection = styled.div`
  border-bottom: 1px solid ${colors.neutral20};
  &:last-of-type {
    border-bottom: none;
  }
`;

export const FilterSectionToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px 20px;
  background: none;
  border: none;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.bigBangBlack};
  cursor: pointer;
  text-align: left;
  transition: background 0.1s;
  &:hover {
    background: ${colors.neutral5};
  }
`;

export const FilterSectionChevron = styled.span`
  font-size: 10px;
  color: #999;
  transition: transform 0.2s;
  [data-collapsed='true'] & {
    transform: rotate(-90deg);
  }
`;

export const FilterSectionBody = styled.div`
  padding: 0 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: 240px;
  overflow-y: auto;
  [data-collapsed='true'] & {
    display: none;
  }
`;

export const FilterCheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  cursor: pointer;
`;

export const FilterCheckboxInput = styled.input`
  width: 14px;
  height: 14px;
  margin: 0;
  flex-shrink: 0;
  accent-color: #4338ca;
  cursor: pointer;
`;

export const FilterCheckboxLabel = styled.label`
  font-size: 13px;
  font-weight: 400;
  color: #555;
  cursor: pointer;
  line-height: 1.4;
  user-select: none;
`;

export const FilterSectionSort = styled.div`
  padding: 16px 20px;
  border-top: 1px solid ${colors.neutral20};
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FilterSectionSortLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.bigBangBlack};
`;

export const FilterSectionSortSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid ${colors.neutral20};
  border-radius: 6px;
  font-family: inherit;
  font-size: 13px;
  background: #fff;
  width: 100%;
  cursor: pointer;
`;
